import Comment from './Comment'
import useModal from '../../../../../lib/hooks/useModal'
import { formatDateTime } from '../../../../../lib/utils'
import { ModalName } from '../../../../../types'
import { Comment as CommentType } from '../../../../../generated/graphql'
import { useAuth } from '../../../../provider/OIDCProvider'

type CommentWrapperProps = {
  /** optional css class */
  className?: string
  /** The comment object */
  comment: CommentType
  /** Indicates if this plan is a template */
  isTemplate: boolean
  /** Indicates if this plan/template is read-only */
  readOnly?: boolean | undefined
  /** Hide the new comment indicator after the comments have been viewed */
  showNewCommentIndicator: boolean
}

const CommentWrapper = ({
  className = '',
  comment,
  readOnly = false,
  isTemplate,
  showNewCommentIndicator
}: CommentWrapperProps) => {
  const { user } = useAuth()
  const { showModal } = useModal()
  // Only show the delete if the comment was added by the current user.
  // Never show delete if it's a read-only template
  const showDelete = !readOnly && user && user.appUserId === comment.createdByAppUserId
  const formattedDate = formatDateTime(comment.createdAt)

  const formatName = () => {
    if (comment.creatorName && comment.creatorName.trim()) {
      return comment.creatorName
    }
    // no creatorName, here's a placeholder
    return user && user.appUserId === comment.createdByAppUserId ? 'Current User' : 'Shared User'
  }

  const handleDelete = () => {
    showModal(ModalName.ConfirmDeleteComment, { id: comment.id })
  }

  return (
    <Comment
      className={className}
      comment={comment.comment}
      date={formattedDate || ''}
      id={comment.id}
      isTemplate={isTemplate}
      name={formatName()}
      onDelete={handleDelete}
      read={comment.read}
      showDelete={showDelete || false}
      showNewCommentIndicator={showNewCommentIndicator}
    />
  )
}

export default CommentWrapper
